import {Button} from "@client/components/Button";
import * as orm from "@client/features/orm";
import * as subscriptions from "@client/features/subscriptions";
import * as forms from "@client/forms";
import * as router from "@client/router";
import * as React from "react";

export const ConfirmPayPal = router.ConfirmPayPal.withHooks((props) => {
    const PayerID = props.location.query.get("PayerID");
    const paymentId = props.location.query.get("paymentId");
    return {
        PayerID,
        paymentId,
        subscriptionDollarsPerYear: props.useSelector(
            (state) => orm.getCredentials(state)!.SUBSCRIPTION_DOLLARS_PER_YEAR,
        ),
        confirmPayPal: async () => {
            await props.dispatch(
                subscriptions.confirmPayPal({
                    payer_id: PayerID!,
                    payment_id: paymentId!,
                }),
            );
            void router.push("profile.profile", {});
        },
    };
})
    .withIndex((props) => (
        <div>
            {/* oxlint-disable-next-line typescript/strict-boolean-expressions */}
            {props.paymentId && props.PayerID ? (
                <forms.FormShell>
                    <p>
                        Please confirm your purchase of a yearly subscription. You will
                        be billed ${props.subscriptionDollarsPerYear}.
                    </p>
                    <p>Paid subscriptions help keep Joy ad-free.</p>
                    <Button onClick={props.confirmPayPal}>Confirm</Button>
                </forms.FormShell>
            ) : (
                <forms.FormShell>
                    <p>You cancelled your purchase.</p>
                    <p>Paid subscriptions help keep Joy ad-free.</p>
                    <Button href="/paypal/">Purchase</Button>
                </forms.FormShell>
            )}
        </div>
    ))
    .withActions(() => [])
    .withOptions(() => ({
        title: "Confirm Subscription",
    }));
